import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useLoadingStore } from '@/stores/loading'
import { useSlugHelper } from '@/router/useSlugHelper'

const Names = {
  fr: 'politique-temoins-connexion',
  en: 'cookie-policy'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: `/${Names.fr}`,
  alias: `/${Names.en}`,
  meta: {
    title: {
      fr: 'Politique relative aux témoins de connexion',
      en: 'Cookie Policy'
    },
    description: {
      fr: 'Consultez cette page pour prendre connaissance de notre politique relative aux témoins de connexion.',
      en: 'Visit this page to read our cookie policy.'
    }
  },
  component: () => import('@page/cookiePolicy/CookiePolicy.vue'),
  beforeEnter: async (to, from, next) => {
    const loadingStore = useLoadingStore()
    loadingStore.toggleLoading({ set: true })
    next(await useSlugHelper().checkPageSlug(to.path, Names))
  }
}

export { Config }
